import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../i18n/LanguageContext";

const stats = [
  { value: "420", key: "stats_years" },
  { value: "27+", key: "stats_langs" },
  { value: "12", key: "stats_offices" },
  { value: "300+", key: "stats_projects" },
];

export const Stats = () => {
  const { t } = useLang();
  return (
    <section className="relative border-y border-white/10 bg-[#08080A]" data-testid="stats-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 grid grid-cols-2 lg:grid-cols-4 gap-8">
        {stats.map((s, i) => (
          <motion.div
            key={s.key}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.1 }}
            className="text-center lg:text-left"
            data-testid={`stat-${s.key}`}
          >
            <div className="font-head font-extrabold text-4xl sm:text-5xl text-white glow-text">{s.value}</div>
            <div className="mt-2 text-xs sm:text-sm text-zinc-500 font-mono uppercase tracking-wide">{t(s.key)}</div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
